import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  PresentationalDataExportAllowToolsModalComponent, type PresentationalDataExportAllowToolsModalProps,
} from './presentationalDataExportAllowToolsModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    PresentationalDataExportAllowTool: PresentationalDataExportAllowToolsModalProps;
  }
}

modalRenderer.register('PresentationalDataExportAllowTool', PresentationalDataExportAllowToolsModalComponent);
